import * as React from "react";
import BaseComponent from "src/engine/ui/BaseComponent";
import "./index.scss";

interface IProps {
    onClose: () => void;
}

interface IState {}

// 服务协议
class ServiceModal extends BaseComponent<IProps, IState> {
    render() {
        const { onClose } = this.props;
        return (
            <div className="service-modal">
                <div className="service-content">
                    <div className="btn-close" onClick={onClose}></div>
                    <div className="iframe-box">
                        <iframe
                            src={"https://acts.jj.cn/html/activity_topic/static/221019171a46.html?t=12&type=m_hxz_web"}
                            // src={"https://acts.jj.cn/agreement/agreement_template.html?id=8320C12355F8B3361D23ED889900EFD81DE680A5D4ED95A98656B6133F1DC8D0"}
                            height={"100%"}
                            width={"100%"}
                            name="iframe-service"
                            frameBorder="0"
                            scrolling="no"
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default ServiceModal;
